import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/panel.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import * as reactUtils from '../../../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import { InnerRefPropType } from '../../../packages/props-utils/prop-types.js';
import { usePanelContext } from '../panel-context.js';
import { useScrollableTabIndex } from '../../../hooks/_use-scrollable-tab-index/use-scrollable-tab-index.js';

const bemPanel = new HoneyBem('panel', styles);
function PanelContent(_a) {
  var {
      children,
      extraClasses,
      innerRef
    } = _a,
    rest = __rest(_a, ["children", "extraClasses", "innerRef"]);
  const contentRef = React.useRef(null);
  const {
    active,
    loading
  } = usePanelContext();
  const tabIndexValue = useScrollableTabIndex(active, Boolean(loading), contentRef);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: node => {
      reactUtils.assignInnerRefWithComponentRef(node, innerRef, contentRef);
    },
    tabIndex: tabIndexValue,
    className: bemPanel.e('content', {}, extraClasses)
  }, rest), children);
}
PanelContent.displayName = 'PanelContent';
PanelContent.propTypes = {
  extraClasses: PropTypes.string,
  children: PropTypes.node.isRequired,
  innerRef: InnerRefPropType
};

export { PanelContent as default };
